import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page_mantenimiento',
  templateUrl: './page_mantenimiento.component.html',
  styleUrls: ['./page_mantenimiento.component.css']
})
export class Page_mantenimientoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
